/* P&J: calculadora de alfombras a medida de Rols.
 *
 * El plan de la tienda es Basic, asi que no se puede cambiar el precio en el
 * carrito: esto calcula y manda la peticion por el formulario de contacto.
 *
 * La formula es la de Rols y esta comprobada al centimo contra cuatro casos
 * reales (ver CHANGELOG-PJ.md). Si se toca, hay que volver a comprobarlos.
 */
(function () {
  'use strict';

  function euros(p) {
    // Formato español: 1.239 € para los enteros, 89,99 € por debajo de 99.
    // A mano y no con toLocaleString('es-ES'): depende de los datos de idioma
    // que traiga el navegador y en algunos sale "1679 €", sin el punto.
    if (p < 99) return p.toFixed(2).replace('.', ',') + ' €';
    return String(Math.round(p)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' €';
  }

  // El precio terminado en 9 inmediatamente inferior o igual.
  function baja9(p) {
    if (p < 99) return Math.floor(p) - 1 + 0.99;
    var n = Math.floor(p);
    return n - (((n - 9) % 10) + 10) % 10;
  }

  // El siguiente terminado en 9, hacia arriba.
  function sube9(p) {
    if (p < 99) {
      var c = Math.ceil(p) - 1 + 0.99;
      return c >= p ? c : Math.ceil(p) + 0.99;
    }
    var n = Math.ceil(p);
    return n + (((9 - n) % 10) + 10) % 10;
  }

  // Material en m2. Para cada ancho de rollo se mira si cabe de un lado o del
  // otro, y se gasta la opcion mas pequena. Devuelve null si no cabe en ninguno.
  function materialRect(corto, largo, rollos) {
    var ops = [];
    rollos.forEach(function (R) {
      if (R >= corto) ops.push(R * largo);
      if (R >= largo) ops.push(R * corto);
    });
    return ops.length ? Math.min.apply(null, ops) : null;
  }

  function materialRedonda(d, rollos) {
    var caben = rollos.slice().sort(function (a, b) { return a - b; })
                      .filter(function (R) { return R >= d; });
    return caben.length ? caben[0] * d : null;
  }

  function calcula(tarifa, clave, forma, a, b, acabado) {
    var col = tarifa.colecciones[clave];
    if (!col) return { error: 'coleccion' };
    var mat, perim;
    if (forma === 'redonda') {
      var d = a / 100;
      mat = materialRedonda(d, col.rollos);
      perim = Math.PI * d;
    } else {
      var lados = [a / 100, b / 100].sort(function (x, y) { return x - y; });
      mat = materialRect(lados[0], lados[1], col.rollos);
      perim = 2 * (lados[0] + lados[1]);
    }
    if (mat === null) return { error: 'medida' };
    var eurM = (tarifa.acabados[acabado] || { eur_m: 0 }).eur_m;
    var X = mat * col.eur_m2 + perim * eurM;
    var f = tarifa.formula_minimo;
    var final = Math.max(baja9(X * tarifa.iva), sube9((f.a * X + f.b) / f.c));
    return { material: mat, sinIva: X, conIva: X * tarifa.iva, precio: final };
  }

  function arranca(caja) {
    var tarifa, datos;
    try {
      tarifa = JSON.parse(document.getElementById(caja.dataset.tarifa).textContent);
      datos = JSON.parse(caja.querySelector('[data-pj-rols-datos]').textContent);
    } catch (e) { return; }

    var col = tarifa.colecciones[datos.coleccion];
    if (!col) { caja.hidden = true; return; }

    var $ = function (s) { return caja.querySelector(s); };
    var forma = $('[data-pj-forma]'), ancho = $('[data-pj-ancho]'), largo = $('[data-pj-largo]'),
        diam = $('[data-pj-diametro]'), color = $('[data-pj-color]'), acab = $('[data-pj-acabado]'),
        salida = $('[data-pj-resultado]'), aviso = $('[data-pj-aviso]'), pedir = $('[data-pj-pedir]'),
        filaRect = $('[data-pj-fila-rect]'), filaRed = $('[data-pj-fila-redonda]');

    // Los acabados los manda la tarifa, no el marcado: asi anadir uno nuevo
    // el ano que viene es tocar un solo archivo.
    if (acab && !acab.options.length) {
      (col.acabados || []).forEach(function (k) {
        var o = document.createElement('option');
        o.value = k;
        o.textContent = (datos.acabados && datos.acabados[k]) || k;
        acab.appendChild(o);
      });
    }

    var maxLado = Math.max.apply(null, col.rollos) * 100;
    var maxLargo = col.largo_max * 100;
    var minCm = tarifa.minimo_cm;
    [ancho, largo, diam].forEach(function (c) { if (c) c.min = minCm; });
    if (ancho) ancho.max = maxLado;
    if (largo) largo.max = maxLargo;
    if (diam) diam.max = maxLado;

    function esRedonda() { return forma ? forma.value === 'redonda' : datos.forma === 'redonda'; }

    function pinta() {
      var redonda = esRedonda();
      if (filaRect) filaRect.hidden = redonda;
      if (filaRed) filaRed.hidden = !redonda;

      var a = redonda ? parseFloat(diam.value) : parseFloat(ancho.value);
      var b = redonda ? null : parseFloat(largo.value);
      var faltan = !a || (!redonda && !b);

      salida.hidden = true; aviso.hidden = true;
      if (pedir) pedir.disabled = true;
      if (faltan) return;

      var fuera = a < minCm || (!redonda && b < minCm) ||
                  (redonda && a > maxLado) ||
                  (!redonda && (Math.min(a, b) > maxLado || Math.max(a, b) > maxLargo));
      var r = fuera ? { error: 'medida' }
                    : calcula(tarifa, datos.coleccion, redonda ? 'redonda' : 'rectangular', a, b, acab.value);

      if (r.error) { aviso.hidden = false; return; }

      salida.querySelector('[data-pj-precio]').textContent = euros(r.precio);
      salida.hidden = false;
      if (pedir) pedir.disabled = false;

      // Lo que viaja en el formulario de contacto.
      var medidas = redonda ? ('Ø' + a + ' cm') : (a + ' x ' + b + ' cm');
      var oculto = {
        'pj-medidas': medidas,
        'pj-forma': redonda ? 'Redonda' : 'Rectangular',
        'pj-color': color ? color.value : '',
        'pj-acabado': acab.options[acab.selectedIndex] ? acab.options[acab.selectedIndex].text : '',
        'pj-precio': euros(r.precio)
      };
      Object.keys(oculto).forEach(function (k) {
        var campo = caja.querySelector('[data-pj-oculto="' + k + '"]');
        if (campo) campo.value = oculto[k];
      });
    }

    [forma, ancho, largo, diam, color, acab].forEach(function (c) {
      if (c) { c.addEventListener('input', pinta); c.addEventListener('change', pinta); }
    });
    pinta();
  }

  function todas() {
    document.querySelectorAll('[data-pj-rols]').forEach(function (c) {
      if (!c.dataset.pjListo) { c.dataset.pjListo = '1'; arranca(c); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todas);
  else todas();
  document.addEventListener('shopify:section:load', todas);
})();
